import { useNavigate, useParams } from "react-router";

import type { PATHS } from "@/routes/paths";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info";

import type { ParamParseKey } from "react-router";

export const useGetOptionStockDeprecatedPageParams = () => {
	const { hotelID } = useParams<ParamParseKey<typeof PATHS.HOTEL.ITEMS.OPTION.STOCK_DEPRECATED>>();

	const navigate = useNavigate();

	if (!hotelID) {
		notifyUserEventInfo({
			title: "無効なURLです",
			description: "",
		});

		navigate("/");
	}

	return {
		hotelID: hotelID!,
	};
};
